export default "__VITE_ASSET__BQ4q5P$___"